<app-rule-list class="main-container"/>

@if (rule$ | async; as rule) {
  <app-card class="detail-container">
    <div class="header reverse">
      <h2 class="line-clamp">{{ rule | ruleName }}</h2>
      <a class="button icon-button end" [routerLink]="['/', RouteConstants.routeRule]">
        <app-icon name="ic_close"/>
      </a>
    </div>
    <div class="content">
      @if (rule.isSystemRule) {
        <app-tag>{{'rules.systemRule.label' | translate}}</app-tag>
      }

      <h3>{{ 'rules.condition' | translate }}</h3>
      @for (c of rule.conditions; track c.id) {
        <div class="item">
          <app-text-with-icon [name]="c.type | icons">{{ 'rules.detail.conditionType.' + c.type | translate }}</app-text-with-icon>
          <ng-container *ngTemplateOutlet="ruleConditionTemplate; context: {condition: c}"></ng-container>
        </div>
      }

      @if (rule.orConditions.length > 0) {
        <h3>{{ 'rules.orCondition' | translate }}</h3>
        @for (c of rule.orConditions; track c.id) {
          <div class="item">
            <app-text-with-icon [name]="c.type | icons">{{ 'rules.detail.conditionType.' + c.type | translate }}</app-text-with-icon>
            <ng-container *ngTemplateOutlet="ruleConditionTemplate; context: {condition: c}"></ng-container>
          </div>
        }
      }

      <h3>{{ 'rules.action' | translate }}</h3>
      @for (a of rule.actions; track a.id) {
        <div class="item">
          @if (a.device) {
            <app-text-with-icon [name]="a.device.type | icons">{{ a.device.name }}</app-text-with-icon>
          } @else if (a.deviceGroup) {
            {{ a.deviceGroup.name }}
          }
          @if (a.duration !== undefined && a.duration !== null) {
            <p>{{ ('rules.detail.' + (a.value ? 'activeForMin' : 'inactiveForMin')) | translate:{min: a.duration} }}</p>
          } @else {
            <p>{{ ('rules.detail.' + (a.value ? 'active' : 'inactive')) | translate }}</p>
          }
        </div>
      }
    </div>
    <div class="footer flex wrap">
      @if(!rule.isSystemRule) {
        <a [routerLink]="['/', RouteConstants.routeRule, RouteConstants.routeUpdate, rule.id]"
          class="button primary-button">{{ 'rules.edit' | translate }}</a>
      }
    </div>
  </app-card>
}

<ng-template #ruleConditionTemplate
             let-c="condition">
  <p>
    @if (c.time && c.repetitionMode) {
      {{ LabelConverter.getRepetitionModeLabel(c.repetitionMode) | translate }}: {{ c.time | time }}@if (c.repetitionInterval) {,
        @if (c.repetitionMode === RepetitionMode.DAILY) {
          @if (c.repetitionInterval === 1) {
            {{ 'rules.detail.repetitionInterval.everyDay' | translate }}
          } @else {
            {{ 'rules.detail.repetitionInterval.everyNthDay' | translate:{nth: c.repetitionInterval} }}
          }
        } @else if (c.repetitionMode === RepetitionMode.WEEKLY) {
          @if (c.repetitionInterval === 1) {
            {{ 'rules.detail.repetitionInterval.everyWeek' | translate }}
          } @else {
            {{ 'rules.detail.repetitionInterval.everyNthWeek' | translate:{nth: c.repetitionInterval} }}
          }
        }
      }
      @if (c.repetitionDays && c.repetitionDays.length > 0) {
        (@for (day of sortWeekDays(c.repetitionDays); track day; let last = $last) {{{ LabelConverter.getWeekDaysLabel(day) | translate }}@if (!last) {, }})
      }
    } @else if (c.weather && c.forecastPeriod) {
      {{ LabelConverter.getForecastPeriodLabel(c.forecastPeriod) | translate }}: {{ LabelConverter.getWeatherLabel(c.weather) | translate }}
    } @else if (c.sensorDeviceName && c.comparisonType && c.threshold) {
      {{ c.sensorDeviceName }}: {{ LabelConverter.getRuleConditionComparisonTypeLabel(c.comparisonType) | translate }} {{ c.threshold | localizedPercent }}
    } @else if (c.cisternSensorDeviceName && c.comparisonType && c.threshold) {
      {{ c.cisternSensorDeviceName }}: {{ LabelConverter.getRuleConditionComparisonTypeLabel(c.comparisonType) | translate }} {{ c.threshold | localizedPercent }}
    }
  </p>
</ng-template>
